"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.convertMetaobjectFields = void 0;
/*
  This function does three things:
  1. convert list of MetaobjectField to object (and cast as a given type)
  2. change the key from snake_case to camelCase
  3. convert string to JS object if the field type is json

  e.g.,
  convert from
  [{
    key: 'xxx_nnn',
    value: 'yyy',
    type: 'json',
  },
  {
    key: 'aaa_mmm',
    value: 'bbb',
    type: 'text',
  }, ...]
  to
  {
    xxxNnn: {
      [jsonFormat of yyy]
    },
    aaaMmm: 'bbb',
  }
*/
var convertMetaobjectFields = function (fields) {
    return fields.reduce(function (acc, curr) {
        var _a;
        // return the accumulated value if current value is not set
        if (!curr.value) {
            return __assign({}, acc);
        }
        // add a new value with camelized key and json parsed value
        // to the accumulated value
        return __assign(__assign({}, acc), (_a = {}, _a[camelize(curr.key)] = curr.type === 'json' ? JSON.parse(curr.value) : curr.value, _a));
    }, {});
};
exports.convertMetaobjectFields = convertMetaobjectFields;
// Convert snake_case string to camelCase
var camelize = function (str) { return str.replace(/_./g, function (match) { return match[1].toUpperCase(); }); };
